export const DAY_IN_MILISECS = 1000 * 60 * 60 * 24;
export const YEAR_IN_MILISECS = DAY_IN_MILISECS * 365.25;
export const SIX_MONTHS_AHEAD_IN_DAYS = 180;

interface dateDifferenceInDaysProps {
  date: Date;
  today: Date;
}

export const dateDifferenceInDays = ({date, today}: dateDifferenceInDaysProps) => {
  return Math.abs(date.getTime() - today.getTime()) / DAY_IN_MILISECS;
};
